import React from 'react';

import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Navigation from '../Navigation/Navigation';
import PanelContainer from './PanelContainer';

import * as classes from './AttributeManagement.module.css';

const AttributeManagement = ({
    ...props
}) => {

    return (
        <BobPage>
            <div className={classes.AttributeManagementPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                </div>
                <div className={classes.TitlePanel}>
                    Attribute Management
                </div>
                <div className={classes.TablePanel}>
                    <PanelContainer />
                </div>
            </div>
        </BobPage>
    );
};

export default AttributeManagement;
